import { createConfig, lazyRoute } from "../config/config-utils"

const SelectCorrectTranslationApp = lazyRoute(
  ()=> import("./SelectCorrectTranslation"),
  "SelectCorrectTranslationApp",
)

export const SELECT_CORRECT_TRANSLATION_CONFIG = createConfig({
  component: SelectCorrectTranslationApp,
  key: "select-correct-translation",
  label: "Select Correct Translation",
})

export const SELECT_CORRECT_TRANSLATION_LANGUAGE_OPTIONS = {
  bulgarian: {
    speakSpeed: 1,
  },
  finnish: {
    speakSpeed: 1,
  },
  french: {
    speakSpeed: 0.75,
  },
  german: {
    speakSpeed: 1,
  },
  greek: {
    speakSpeed: 1,
  },
  italian: {
    speakSpeed: 1,
  },
  portuguese: {
    speakSpeed: 1,
  },
  spanish: {
    speakSpeed: 1,
  },
}
